import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectMeasurementRecipientsImportDomain = (state) =>
  state.get("measurementRecipientsImport", initialState)

export const makeSelectIsDownloading = () =>
  createSelector(selectMeasurementRecipientsImportDomain, (state) =>
    state.get("isDownloading")
  )

export const makeSelectIsUploading = () =>
  createSelector(selectMeasurementRecipientsImportDomain, (state) =>
    state.get("isUploading")
  )

const makeSelectMeasurementRecipientsImport = () =>
  createSelector(selectMeasurementRecipientsImportDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectMeasurementRecipientsImport
export { selectMeasurementRecipientsImportDomain }
